module.exports = __webpack_public_path__ + "img/costs-tractor.688fc862.svg";